module.exports = PSCampaign;